import { useUIStore } from '@/stores/uiStore';

// Export a hook that matches the old API
export function useTheme() {
  const theme = useUIStore(state => state.theme);
  const toggleTheme = useUIStore(state => state.toggleTheme);

  return { theme, toggleTheme };
}
